module.exports = __webpack_public_path__ + "static/media/SM_worldSoccer_1@2x.8c731045.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/SM_worldSoccer_1@2x.png
// module id = 173
// module chunks = 0